"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
const LineItem = ({ label, value, isTotal = false, isCheckout = false, dataSelector = '', oneDiscount = false }) => {
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)(styles_module_scss_1.default.container, { [styles_module_scss_1.default.isTotal]: isTotal, [styles_module_scss_1.default.isCheckout]: isCheckout, [styles_module_scss_1.default.oneDiscount]: oneDiscount }), children: [(0, jsx_runtime_1.jsx)("div", { className: styles_module_scss_1.default.label, children: label }), (0, jsx_runtime_1.jsx)("div", { className: styles_module_scss_1.default.value, "data-selector": dataSelector, children: value })] }));
};
LineItem.propTypes = {
    /* Line item label */
    label: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.element]),
    /* Line item value */
    value: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.element]),
    /* Special styling for Total line item */
    isTotal: prop_types_1.default.bool,
    /* Special styling for Checkout line item */
    isCheckout: prop_types_1.default.bool,
    /* Data attribute for testing */
    dataSelector: prop_types_1.default.string
};
exports.default = LineItem;
//# sourceMappingURL=index.js.map